export const SESSION_STATUS = {
  READY: 'READY',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  READY_NOT_STARTED: 'READY_NOT_STARTED',
  READY_NO_ROUND: 'READY_NO_ROUND',
};
